export default {
    getAdditionalTableConfig: state => state.dataTableOptions,
    getSearchHeaderFields: state => state.searchFields,
    getHeaderFields: state => state.headerFields,
    getActions: state => state.actions
}
